import React, { useEffect, useRef, useState } from "react";
import {
    TextField,
    Button,
    Grid,
    IconButton,
    Divider,
    Box,
    Avatar,
    Typography,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from "@mui/material";
import {
    AddCircle,
    Print,
    RemoveCircle,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import authService from "../Auth/AuthService";
import AuthService from "../Auth/AuthService";
import { getAcademicYear } from "../utils/academicYear";

const EntryCardForm = ({ entryCard, standard, onSuccess }) => {
    const navigate = useNavigate();
    const hasFetched = useRef(false);
    const academicYear = getAcademicYear();
    const school = (() => {
        try {
            return JSON.parse(sessionStorage.getItem("school") || "null");
        } catch (error) {
            console.error("Invalid school data in sessionStorage:", error);
            return null;
        }
    })();
    const [formDB, setFormDB] = useState([]);
    const [removeForm, setRemoveForm] = useState([]);
    const [form, setForm] = useState([
        {
            subject: "",
            days: "",
            examDate: "",
        },
    ]);

    const [notes, setNotes] = useState({
        note: "The admit card is essential and must be carried to the exam centre. Candidates may also need to carry a valid photo ID proof for written, oral, and signal examinations.",
    });

    const [times, setTimes] = useState({
        startTime: "",
        endTime: "",
    });

    const getDayName = (dateString) => {
        if (!dateString) {
            return "";
        }

        const [year, month, day] = dateString.split("-");

        const date = new Date(
            Number(year),
            Number(month) - 1,
            Number(day)
        );

        return date.toLocaleDateString("en-US", {
            weekday: "long",
        });
    };

    const handleMarkChange = (index, e) => {
        const { name, value } = e.target;

        setForm((prevForm) =>
            prevForm.map((item, i) => {
                if (i !== index) {
                    return item;
                }

                const updatedItem = {
                    ...item,
                    [name]: value,
                };

                if (name === "examDate") {
                    updatedItem.days = getDayName(value);
                }

                return updatedItem;
            })
        );
    };

    const addSubject = () => {
        setForm((prevForm) => [
            ...prevForm,
            {
                subject: "",
                days: "",
                examDate: "",
            },
        ]);
    };

    const removeSubject = (index) => {
        setForm((prevForm) => {
            if (prevForm.length === 1) {
                return prevForm;
            }

            const removedItem = prevForm[index];

            if (removedItem?.id) {
                setRemoveForm((prevRemoveForm) => {
                    const alreadyExists = prevRemoveForm.some(
                        (item) => item.id === removedItem.id
                    );

                    if (alreadyExists) {
                        return prevRemoveForm;
                    }

                    return [...prevRemoveForm, removedItem];
                });
            }

            return prevForm.filter((_, i) => i !== index);
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setNotes((prevNotes) => ({
            ...prevNotes,
            [name]: value,
        }));
    };

    const handleTimeChange = (e) => {
        const { name, value } = e.target;

        setTimes((prevTimes) => ({
            ...prevTimes,
            [name]: value,
        }));
    };

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;
        loadData();
    }, []);

    const loadData = async () => {
        try {

            const url = AuthService.pathUrl("GET", "/entry-card");
            const response = await AuthService.getAuth(url);

            const data = response || [];
            if (data.length > 0) {
                setTimes({
                    startTime: data[0].startTime || "",
                    endTime: data[0].endTime || "",
                });
            }
            if (Array.isArray(data)) {
                setForm(data.filter((item) => item.standard === standard));
                setFormDB(data);
            } else {
                console.error(
                    "Entry Card response is not an array:",
                    data
                );
            }
        } catch (error) {
            console.error(
                "Error fetching entry card:",
                error
            );
        }
    };

    const postData = async () => {
        try {
            const url = authService.pathUrl(
                "POST", "/entry-card/bulk"
            );
            const newform = form.map(item => {
                const updatedItem = {
                    ...item,
                    ...times,
                    standard: standard,
                    academicYear: academicYear,
                };
                return updatedItem;
            })

            await authService.postAuth(url, newform);

            return true;
        } catch (error) {
            console.error("Error saving entry card:", error);

            alert(
                "Error while saving Entry Card. Please try again."
            );

            return false;
        }
    };

    const deleteData = async () => {
        if (!removeForm || removeForm.length === 0) {
            return;
        }

        try {
            const url = authService.pathUrl("DELETE", "/entry-card/bulk");

            await authService.deleteAuth(url, removeForm);

            return true;
        } catch (error) {
            console.error("Error delete entry card:", error);

            alert(
                "Error while delete Entry Card. Please try again."
            );

            return false;
        }
    };

    // ----------------------------------------------------
    // Create Card
    // ----------------------------------------------------
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (onSuccess) {
            onSuccess(form);
        }

        navigate("/entry-card", {
            state: {
                students: entryCard,
                ...notes,
                entryList: form,
                times: times,
            },
        });
    };

    // ----------------------------------------------------
    // Print timetable
    // ----------------------------------------------------
    const printTimeTable = async () => {
        // Validate time
        if (!times.startTime && !times.endTime) {
            alert("Please enter Start Time or End Time.");
            return;
        }

        const deleted = await deleteData();
        console.log("deleted", deleted);
        const saved = await postData();

        if (!saved) {
            return;
        }
        if (onSuccess) {
            onSuccess(form);
        }
        // // Give React time to update the DOM
        // if (formDB.length === 0) {
        //     setTimeout(() => {
        //         printHtml("time-table");
        //         window.location.reload();
        //     }, 100);
        // }
    };

    return (
        <Box>
            <form onSubmit={handleSubmit}>
                {/* ----------------------------------------
                    Notes
                ----------------------------------------- */}
                <Grid item xs={12} mb={2}>
                    <TextField
                        required
                        label="Notes"
                        name="note"
                        value={notes.note}
                        onChange={handleChange}
                        fullWidth
                        multiline
                        minRows={2}
                    />
                </Grid>

                {/* ----------------------------------------
                    Exam Time
                ----------------------------------------- */}
                <Grid
                    container
                    spacing={2}
                    mb={2}
                    alignItems="center"
                >
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label="Start Time"
                            name="startTime"
                            type="time"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            value={times.startTime}
                            onChange={handleTimeChange}
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={12} sm={3}>
                        <TextField
                            label="End Time"
                            name="endTime"
                            type="time"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            value={times.endTime}
                            onChange={handleTimeChange}
                            fullWidth
                        />
                    </Grid>
                </Grid>

                <Divider sx={{ mb: 3 }} />

                {/* ----------------------------------------
                    Subjects
                ----------------------------------------- */}
                {form.map((mark, index) => (
                    <Grid
                        container
                        spacing={2}
                        mb={2}
                        alignItems="center"
                        key={index}
                    >
                        <Grid item xs={12} sm={3}>
                            <TextField
                                required
                                label="Subject"
                                name="subject"
                                value={mark.subject}
                                onChange={(e) =>
                                    handleMarkChange(index, e)
                                }
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <TextField
                                required
                                label="Day"
                                name="days"
                                value={mark.days}
                                fullWidth
                                disabled
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <TextField
                                required
                                label="Standard"
                                name="standard"
                                value={mark.standard}
                                // fullWidth
                                disabled
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <TextField
                                required
                                label="Exam Date"
                                name="examDate"
                                type="date"
                                slotProps={{
                                    inputLabel: {
                                        shrink: true,
                                    },
                                }}
                                value={mark.examDate}
                                onChange={(e) =>
                                    handleMarkChange(index, e)
                                }
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={12} sm={1}>
                            <IconButton
                                type="button"
                                color="error"
                                onClick={() =>
                                    removeSubject(index)
                                }
                            >
                                <RemoveCircle />
                            </IconButton>
                        </Grid>
                    </Grid>
                ))}

                {/* ----------------------------------------
                    Buttons
                ----------------------------------------- */}
                <Box sx={{ mb: 3 }}>
                    <Button
                        type="button"
                        startIcon={<AddCircle />}
                        onClick={addSubject}
                        sx={{
                            mt: 2,
                            color: "#1b1914",
                            fontWeight: "bold",
                        }}
                    >
                        Add Subject
                    </Button>

                    <Button
                        type="submit"
                        variant="contained"
                        sx={{
                            mt: 3,
                            ml: 2,
                            bgcolor: "#1b1914",
                            borderRadius: 5,
                        }}
                    >
                        Create Entry Card
                    </Button>

                    <Button
                        type="button"
                        startIcon={<Print />}
                        onClick={printTimeTable}
                        variant="contained"
                        sx={{
                            mt: 3,
                            ml: 2,
                            bgcolor: "#1b1914",
                            borderRadius: 5,
                        }}
                    >
                        submit
                    </Button>
                </Box>
            </form>

            {/* ----------------------------------------
                Printable Time Table
                IMPORTANT:
                Use && correctly
            ----------------------------------------- */}
            {(times.startTime || times.endTime) && formDB.length === 0 && (
                <Box id="time-table">
                    {/* ------------------------------------
                        Print Header
                    ------------------------------------- */}
                    <Box
                        sx={{
                            display: "none",

                            "@media print": {
                                display: "flex",
                            },

                            alignItems: "center",
                            bgcolor: "#fff",
                            borderBottom: "1px solid #ddd",
                            p: 0.4,
                            gap: 1.5,
                            m: 2,
                        }}
                    >
                        {school?.logoUrl && (
                            <Avatar
                                src={school.logoUrl}
                                alt="School Logo"
                                sx={{
                                    width: 60,
                                    height: 60,
                                    borderRadius: 1,
                                }}
                            />
                        )}

                        <Box
                            sx={{
                                textAlign: "center",
                                flex: 1,
                            }}
                        >
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    fontWeight: 700,
                                }}
                            >
                                {school?.schoolName || ""}
                            </Typography>

                            <Typography
                                variant="caption"
                                sx={{
                                    display: "block",
                                    fontSize: 12,
                                }}
                            >
                                {[
                                    school?.addressDTO
                                        ?.addressLine1,
                                    school?.addressDTO?.city,
                                    school?.addressDTO?.state,
                                ]
                                    .filter(Boolean)
                                    .join(", ")}

                                {school?.contactPhone && (
                                    <>
                                        {" | Tel: "}
                                        {school.contactPhone}
                                    </>
                                )}
                            </Typography>
                        </Box>
                    </Box>

                    {/* ------------------------------------
                        Exam Times
                    ------------------------------------- */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: 4,
                            mb: 2,
                        }}
                    >
                        {academicYear && (
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    fontWeight: 600,
                                }}
                            >
                                Examination {academicYear}
                            </Typography>
                        )}

                        {standard && (
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    fontWeight: 600,
                                }}
                            >
                                Standard: {standard}
                            </Typography>
                        )}

                        {times.endTime && (
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    fontWeight: 600,
                                }}
                            >
                                Time: {times.startTime} {' - '} {times.endTime}
                            </Typography>
                        )}
                    </Box>

                    {/* ------------------------------------
                        Table
                    ------------------------------------- */}
                    <TableContainer>
                        <Table
                            size="small"
                            sx={{
                                border: "1px solid #999",
                                borderCollapse: "collapse",

                                "& th, & td": {
                                    border: "1px solid #999",
                                    padding: "6px 10px",
                                },

                                "& th": {
                                    fontWeight: 700,
                                    backgroundColor: "#f5f5f5",
                                },

                                "@media print": {
                                    "& th": {
                                        backgroundColor:
                                            "#f5f5f5 !important",
                                        WebkitPrintColorAdjust:
                                            "exact",
                                        printColorAdjust:
                                            "exact",
                                    },
                                },
                            }}
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">
                                        <strong>
                                            Subject
                                        </strong>
                                    </TableCell>

                                    <TableCell align="center">
                                        <strong>
                                            Days
                                        </strong>
                                    </TableCell>

                                    <TableCell align="center">
                                        <strong>
                                            Exam Date
                                        </strong>
                                    </TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {form.map((mark, index) => (
                                    <TableRow key={index}>
                                        <TableCell align="center">
                                            {mark.subject}
                                        </TableCell>

                                        <TableCell align="center">
                                            {mark.days}
                                        </TableCell>

                                        <TableCell align="center">
                                            {mark.examDate}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            )}
        </Box>
    );
};

export default EntryCardForm;
